import { CSSProperties, SVGProps } from 'react'

const ChatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Capa_1"
    x={0}
    y={0}
    style={
      {
        enableBackground: 'new 0 0 60 60'
      } as CSSProperties
    }
    viewBox="0 0 60 60"
    {...props}
  >
    <style>{'.st1{fill:#fff}'}</style>
    <circle
      cx={30}
      cy={30}
      r={28}
      style={{
        fill: '#d3b1e2'
      }}
    />
    <circle cx={23.1} cy={27.8} r={2.4} className="st1" />
    <circle cx={30.2} cy={27.8} r={2.4} className="st1" />
    <path
      d="M45.8 20.3c-.1-.9-.2-1.7-.6-2.5-.6-1.2-1.6-2.1-2.7-2.7-.8-.4-1.6-.5-2.5-.6-.9-.1-1.9-.1-3.2-.1H23.6c-1.3 0-2.4 0-3.2.1-.9.1-1.7.2-2.5.6-1.2.6-2.1 1.6-2.7 2.7-.4.8-.5 1.6-.6 2.5-.1.9-.1 1.9-.1 3.2v9.7c0 1.4 0 2.3.2 3.2.6 2.2 2.3 3.9 4.4 4.4.5.1 1 .2 1.6.2v3.2c0 .3.1.9.5 1.3.4.6 1.1.9 1.8.9.6 0 1.1-.3 1.3-.5.3-.2.6-.4.9-.7l3.7-3c.8-.7 1.1-.8 1.3-1 .3-.1.5-.2.8-.3.3-.1.6-.1 1.6-.1h3.9c1.3 0 2.4 0 3.2-.1.9-.1 1.7-.2 2.5-.6 1.2-.6 2.1-1.6 2.7-2.7.4-.8.5-1.6.6-2.5.1-.9.1-1.9.1-3.2v-8.5c.3-.9.3-2 .2-2.9zM42.7 35c-.1.7-.2 1-.3 1.3-.3.6-.8 1.1-1.4 1.4-.2.1-.6.2-1.3.3h-6.8c-.9 0-1.6 0-2.2.1-.6.1-1.1.3-1.6.6-.6.3-1.1.7-1.8 1.3l-3.2 2.6v-3c0-.9-.7-1.6-1.6-1.6-1.6 0-2 0-2.4-.1-1.1-.3-1.9-1.1-2.2-2.2-.1-.3-.1-.8-.1-2.4v-9.7c0-1.3 0-2.3.1-3 .1-.7.2-1 .3-1.3.3-.6.8-1.1 1.4-1.4.2-.1.6-.2 1.3-.3.7-.1 1.6-.1 3-.1h13.2c1.3 0 2.3 0 3 .1.7.1 1 .2 1.3.3.6.3 1.1.8 1.4 1.4.1.2.2.6.3 1.3.1.7.1 1.6.1 3V32c-.5 1.4-.5 2.3-.5 3z"
      className="st1"
    />
    <circle cx={37.3} cy={27.8} r={2.4} className="st1" />
  </svg>
)
export default ChatIcon
